/**
 * Parseo y validación de coordenadas de entrada. Centraliza el decodificado de
 * strings numéricos (acepta coma o punto decimal) y las reglas de rango
 * geográfico, evitando duplicar esta lógica en los notifiers.
 */
export class CoordinateParseUtil {
  /** Parsea un string decimal aceptando coma o punto como separador; `NaN` si no es numérico. */
  static parseDecimal(value: string | null | undefined): number {
    return parseFloat((value ?? '').replace(',', '.'));
  }

  /** Indica si la latitud es numérica y está dentro de [-90, 90]. */
  static isValidLatitude(lat: number): boolean {
    return !Number.isNaN(lat) && lat >= -90 && lat <= 90;
  }

  /** Indica si la longitud es numérica y está dentro de [-180, 180]. */
  static isValidLongitude(lng: number): boolean {
    return !Number.isNaN(lng) && lng >= -180 && lng <= 180;
  }

  /**
   * Valida un par lat/lng y devuelve un mensaje de error o `null` si es válido.
   * Reutiliza los mensajes del usuario final en ambos notifiers.
   */
  static validateGeographic(lat: number, lng: number): string | null {
    if (Number.isNaN(lat) || Number.isNaN(lng)) {
      return 'Ingresa valores numéricos válidos para latitud y longitud.';
    }
    if (!CoordinateParseUtil.isValidLatitude(lat)) {
      return 'La latitud debe estar entre -90 y 90.';
    }
    if (!CoordinateParseUtil.isValidLongitude(lng)) {
      return 'La longitud debe estar entre -180 y 180.';
    }
    return null;
  }
}